import { t } from '@/core/localization';
import shieldExclamation from '@/core/svg/fa/shield-exclamation.svg';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { enqueueSnackbar } from 'notistack';
export const showErrorApiResponseSnackbar = ({ header, body, error, persist = true }) => {
    if (error?.status === 401) {
        enqueueSnackbar({
            variant: 'warning',
            icon: shieldExclamation,
            header: t('access.denied.label'),
            body: t('user.does.not.have.enough.access.rights'),
            persist,
        });
        return;
    }
    enqueueSnackbar({ variant: 'error', header, body: body ?? getErrorFromException(error), persist });
    console.error(`Api request failed.`, error);
};
